import { render, staticRenderFns } from "./FilterBarSubgenrePills.vue?vue&type=template&id=3cf0603e&scoped=true"
import script from "./FilterBarSubgenrePills.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBarSubgenrePills.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterBarSubgenrePills.vue?vue&type=style&index=0&id=3cf0603e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf0603e",
  null
  
)

export default component.exports